<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="grupo" titulo="Grupo / Control Escolar" [dato]="dato" ></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; background-color: #f5f5f5;">
    <div class="column is-2 is-hidden-mobile menu-izquierda">
        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #f5f5f5; border-radius: 1em;">
            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()" >
                <section class="hero is-primary" style="position: sticky; top: 0; z-index: 10;">
                    <div class="hero-body">
                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;" >
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('periodos_escolares_vigentes', 'periodo-escolar-vigente'); ctrl.cargarCatalogo('carreras_planes', 'carrera-plan'); ctrl.cargarCatalogo('turnos', 'turnos');"></a>

                    <!-- Card 1: Generales -->
                    <div class="card" style="margin-bottom: 20px; padding: 7px;">
                        <div class="card-header">
                            <p class="card-header-title">
                                Generales
                            </p>
                        </div>
                        <div class="card-content">
                            <div class="columns">
                                <div class="column is-6">
                                    <div class="field">
                                        <label class="label">Carrera / Plan:</label>
                                        <div class="control has-icons-left has-icons-right">
                                            <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('carreras_planes_id').hasError('required')}">
                                                <ng-select2
                                                  [disabled]="ctrl.carreras_planes ? ctrl.carreras_planes.length == 0 ? true : false : true"
                                                  name="carreras_planes_id"
                                                  formControlName="carreras_planes_id"
                                                  [options]="ctrl.optionSelect"
                                                  [value]="ctrl.dato.controls.carreras_planes_id.value"
                                                  [data]="ctrl.carreras_planes"></ng-select2>
                                            </div>
                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required')">
                                                <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required')">Este campo es requerido.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-6">
                                    <div class="field">
                                        <label class="label">Periodo Escolar:</label>
                                        <div class="control has-icons-left has-icons-right">
                                            <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('periodos_escolares_id').hasError('required')}">
                                                <ng-select2
                                                  [disabled]="ctrl.periodos_escolares_vigentes ? ctrl.periodos_escolares_vigentes.length == 0 ? true : false : true"
                                                  name="periodos_escolares_id"
                                                  formControlName="periodos_escolares_id"
                                                  [options]="ctrl.optionSelect"
                                                  [value]="ctrl.dato.controls.periodos_escolares_id.value"
                                                  [data]="ctrl.periodos_escolares_vigentes"></ng-select2>
                                            </div>
                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required')">
                                                <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required')">Este campo es requerido.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="columns">
                                <div class="column is-6">
                                    <label class="label">Nivel:</label>
                                    <p class="control has-icons-left has-icons-right">
                                      <input class="input" #nivel type="number" [ngClass]="{'is-danger': ctrl.dato.get('nivel').hasError('required')}"
                                          placeholder="Nivel" formControlName="nivel">
                                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nivel').hasError('required')">
                                          <i class="fa fa-warning"></i>
                                      </span>
                                      <span class="help is-danger" *ngIf="ctrl.dato.get('nivel').hasError('required')">Este campo es requerido.</span>
                                    </p>
                                </div>
                                <div class="column is-6">
                                    <label class="label">Identificador:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('identificador').hasError('required')}"
                                            placeholder="Identificador" formControlName="identificador">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('identificador').hasError('required')">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.get('identificador').hasError('required')">Este campo es requerido.</span>
                                    </p>
                                </div>
                            </div>
                            
                            <div class="columns">
                                <div class="column is-6">
                                    <label class="label">Turno:</label>
                                    <div class="control has-icons-left has-icons-right">
                                      <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('turnos_id').hasError('required')}">
                                        <ng-select2
                                                [disabled]="ctrl.turnos ? ctrl.turnos.length == 0 ? true : false : true"
                                                name="turnos_id"
                                                formControlName="turnos_id"
                                                [options]="ctrl.optionSelect"
                                                [value]="ctrl.dato.controls.turnos_id.value"
                                                [data]="ctrl.turnos"></ng-select2>
                                      </div>
                                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('turnos_id').hasError('required')">
                                        <i class="fa fa-warning"></i>
                                      </span>
                                      <span class="help is-danger" *ngIf="ctrl.dato.get('turnos_id').hasError('required')">Este campo es requerido.</span>
                                    </div>
                                </div>
                                <div class="column is-6">
                                    <label class="label">Capacidad:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('capacidad').hasError('required')}"
                                            placeholder="Capacidad" formControlName="capacidad">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('capacidad').hasError('required')">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.get('capacidad').hasError('required')">Este campo es requerido.</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Card 2: Promoción y admisiones -->
                    <div class="card" style="margin-bottom: 20px; padding: 7px;">
                        <div class="card-header">
                            <p class="card-header-title">
                                Promoción y admisiones
                            </p>
                        </div>
                        <div class="card-content">
                            <div class="columns">
                                <div class="column is-6">
                                    <div class="field">
                                        <label class="label">En campaña?</label><br>
                                        <div class="field">
                                            <div class="b-checkbox is-info is-circular">
                                                <input id="en_campania_si" name="en_campania" value="1" class="styled" type="radio" [checked]="ctrl.dato.get('en_campania').value == 1 ? true : false" formControlName="en_campania">
                                                <label for="en_campania_si">
                                                  Sí
                                                </label>

                                                <input id="en_campania_no" name="en_campania" value="0" class="styled" type="radio" [checked]="ctrl.dato.get('en_campania').value == 0 ? true : false" formControlName="en_campania">
                                                <label for="en_campania_no">
                                                  No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-6">
                                    <div class="field">
                                        <label class="label">Observaciones:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <textarea class="textarea" type="text" placeholder="Observaciones" formControlName="observaciones"></textarea>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Card 3: Estadísticas -->
                    <div class="card" style="margin-bottom: 20px; padding: 7px;">
                        <div class="card-header">
                            <p class="card-header-title">
                                Estadísticas
                            </p>
                        </div>
                        <div class="card-content">
                            <div class="columns">
                                <div class="column">
                                    Al marcar la casilla: "<strong>Realizar conteo?</strong>" y presionar Guardar, se contabilizará el total de hombres y de mujeres del grupo, verifique que el sexo de cada uno correspondan. Esta operación sólo se realizará en una ocasión, verifique que los datos a guardar sean correctos
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-4">
                                    <label class="label">Realizar conteo?</label>
                                    <div class="control has-icons-left has-icons-right">
                                      <div class="b-checkbox is-info">
                                        <input id="contado" class="styled" [checked]="ctrl.dato.get('contado').value == 1 ? true : false"
                                          [disabled]="ctrl.dato.get('contado').value == 1 ? true : false"
                                          (change)="ctrl.dato.get('contado').patchValue(ctrl.dato.get('contado').value == 1 ? 0 : 1)"
                                          type="checkbox">
                                        <label for="contado">
                                          Sí
                                        </label>
                                      </div>
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <label class="label">Total de mujeres al inicio:</label>
                                    <p class="control has-icons-left has-icons-right">
                                      <input class="input" type="number" readonly
                                          placeholder="Total de mujeres al inicio" formControlName="total_mujeres_inicio">
                                    </p>
                                </div>
                                <div class="column is-4">
                                    <label class="label">Total de hombres al inicio:</label>
                                    <p class="control has-icons-left has-icons-right">
                                      <input class="input" type="number" readonly
                                          placeholder="Total de hombres al inicio" formControlName="total_hombres_inicio">
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </form>
        </div>
    </div>
</div>